import { ApolloMutation, html } from '@apollo-elements/lit-apollo';
import { css } from 'emotion';
import './star-rating-block';
import WriteReview from './write-review.graphql';

export class PageWriteReview extends ApolloMutation {
  mutation = WriteReview;
  variables = {
    comment: ``,
  };

  createRenderRoot() {
    return this;
  }
  
  render() {
    return html`
    <div class="page-content ${this.basicStyles}">
      <div class="block-header">휴게소 이야기를 작성해주세요</div>

      <div class="text-editor"></div>

      <hr class="tw-border"/>
      
      <star-rating-block></star-rating-block>

      <div class="block">
        <p class="row">
          <button class="col button button-raised" @click=${this.clickBack}>취소</button>
          <button class="col button button-raised button-fill color-brown" @click="${this.clickUpload}" >작성하기</button>
        </p>        
      </div>      
    </div>
    `;
  }

  clickBack() {
    this.back();
  }

  async clickUpload() {
    const restAreaPage = document.querySelector(`page-rest-area`);
    this.variables = {
      comment: this.querySelector(`.text-editor`)?.textContent,
      id: window.app.views.main.router.currentRoute.params.id,
    };
    await this.mutate();
    restAreaPage.refetch();
    this.back();
  }

  back() {
    window.app.views.main.router.back();
  }

  firstUpdated() {
    this.createTextEditor();
  }

  createTextEditor() {
    this.textEditor = window.app.textEditor.create({
      el: this.querySelector(`.text-editor`),
      placeholder: `Enter text...`,
      mode: `keyboard-toolbar`,
      vlaue: `test`,
    });
  }

  disconnectedCallback() {
    this.textEditor = null;

    super.disconnectedCallback();
  }

  get basicStyles() {
    return css`
    .tw-border {
      border-color: #fcfcfc;
      margin: 0 15px;
      opacity: 0.5;
      border-radius: 10px;
    }
    
    .star-rating-block {
      display: flex;
      align-items: center;
      padding-right: 25px;
    }
    
    .f7-icons.drop {
      font-size: 15px;
      margin-left: auto;
    }
    
    .color-brown {
      background-color: #bea36b;
    }

    .text-editor {
      --f7-text-editor-height: 150px;
    }
    `;
  }
}

customElements.define('page-write-review', PageWriteReview);